import { ReactNode, useState } from "react";
import classNames from "classnames";
import { Button } from "components/UI/buttons/Button";
import styles from "./CGSummary.module.scss";
import stylesForm from "./CGForm.module.scss";
import { SummaryDataType } from "./ConclusionGenerator";
import { Heading } from "components/UI/typography/Heading";
import { CTABlock } from "components/shared/CTABlock";
import { TabButtons } from "@/components/shared/TabButtons";

type CGSummaryProps = {
  summaryData?: SummaryDataType;
  text: string;
  setIsSummary: (val: boolean) => void;
};

export const CGSummary = ({ summaryData = {}, text, setIsSummary }: CGSummaryProps) => {
  const [activeKey, setActiveKey] = useState<string | number>("summary");
  const { originalLength, summaryLength, summaryRatio, textSummarize } = summaryData;

  const textValues = [
    {
      id: "summary-ratio",
      heading: "Summary ratio:",
      value: `${summaryRatio}%`,
    },
    {
      id: "original-length",
      heading: "Original length:",
      value: originalLength,
    },
    {
      id: "summary-length",
      heading: "Summary length:",
      value: summaryLength,
    },
  ];
  return (
    <div className={styles.wrapper}>
      <Heading level={3} className={styles.heading}>
        Summary:
      </Heading>
      <div className={styles.info}>
        {textValues.map(({ id, heading, value }) => (
          <div key={id} className={styles.item}>
            <div className={styles.itemHeading}>{heading}</div>
            <div className={styles.itemValue}>{value + (id !== "summary-ratio" ? " words" : "")}</div>
          </div>
        ))}
      </div>
      <textarea
        rows={10}
        value={activeKey === "original" ? text : textSummarize}
        key={activeKey === "original" ? "text" : "textSummarize"}
        readOnly
        className={classNames(stylesForm.input, stylesForm.text)}
      />
      <div className={styles.bottom}>
        <TabButtons
          items={[
            {
              tabKey: "summary",
              button: "Summary",
            },
            {
              tabKey: "original",
              button: "Original",
            },
          ]}
          activeKey={activeKey}
          breakpoint="none"
          onChange={setActiveKey}
          className={styles.buttons}
        />
        <Button
          tag="button"
          type="secondary"
          onClick={() => setIsSummary(false)}
          className={styles.buttonMain}
        >
          Summarize another text
        </Button>
      </div>
      <CTABlock
        heading={
          <>
            It’s time <span>to jumpstart</span> your paper!{" "}
          </>
        }
        subheading="Delegate your assignment to our experts and they will do the rest."
        btnText="Get custom essay"
      />
    </div>
  );
};
